import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {request} from "../request/request";
import {APP_URL} from "../request/api";

const initialState = {
    columns: [],
    data: [],
    loadingStatus: 'idle',
    error: null
}

export const fetchUpdates = createAsyncThunk(
    'updates/fetchUpdates',
    async({departureId, token}, {rejectWithValue}) => {
        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            }

            const response = await request(
                `${APP_URL}/reports/${departureId}/log`,
                'GET',
                null,
                customHeaders
            );

            return response
        } catch (error) {
            return rejectWithValue(error.status);
        }
    }
);

const updatesSlice = createSlice({
    name: 'details',
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchUpdates.pending, (state) => {
                state.loadingStatus = 'loading';
                state.number = null;
                state.columns = null;
                state.data = null;
                state.error = null;
            })
            .addCase(fetchUpdates.fulfilled, (state, action) => {
                state.loadingStatus = 'idle';
                state.highlighted = action.payload.highlighted;
                state.columns = action.payload.columns;
                state.data = action.payload.data;
                state.error = null;
            })
            .addCase(fetchUpdates.rejected, (state, action) => {
                state.loadingStatus = 'error';
                state.number = null;
                state.columns = null;
                state.data = null;
                state.error = null;
            })
    }
});

export default updatesSlice.reducer;